import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import LandingPage from "./components/LandingPage";
import SalarieList from "./components/SalarieList";
import SalarieForm from "./components/SalarieForm";
import FournisseurList from "./components/FournisseurList";
import FournisseurForm from "./components/FournisseurForm";
import ChargesForm from "./components/ChargesForm";
import ChantierList from "./components/ChantierList";
import ChantierForm from "./components/ChantierForm";
import PrixOuvrageList from "./components/PrixOuvrageList";
import PrixOuvrageForm from "./components/PrixOuvrageForm";
import PrestationList from "./components/PrestationList";
import PrestationForm from "./components/PrestationForm";
import PlombiersList from "./components/PlombiersList";
import PrestationStats from "./components/PrestationStats";
import FraisTransportConfigPage from "./pages/FraisTransportConfigPage";
import "./App.css";
import "./styles/responsive.css";

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
         <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/chantiers" element={<ChantierList />} />
            <Route path="/add" element={<ChantierForm />} />
            <Route path="/edit/:id" element={<ChantierForm />} />
            <Route path="/charges/:id" element={<ChargesForm />} />
            <Route path="/salaries" element={<SalarieList />} />
            <Route path="/salaries/add" element={<SalarieForm />} />
            <Route path="/fournisseurs" element={<FournisseurList />} />
            <Route path="/fournisseurs/add" element={<FournisseurForm />} />
            <Route
              path="/fournisseurs/edit/:id"
              element={<FournisseurForm />}
            />
            <Route path="/prix-ouvrage" element={<PrixOuvrageList />} />
            <Route path="/prix-ouvrage/add" element={<PrixOuvrageForm />} />
            <Route path="/prix-ouvrage/edit/:id" element={<PrixOuvrageForm />} />
            <Route path="/prestations" element={<PrestationList />} />
            <Route path="/prestations/add" element={<PrestationForm />} />
            <Route path="/prestations/edit/:id" element={<PrestationForm />} />
            <Route path="/plombiers" element={<PlombiersList />} />
            <Route path="/prestation-stats" element={<PrestationStats />} />
            <Route
              path="/frais-transport"
              element={<FraisTransportConfigPage />}
            />
          </Routes>
      </div>
    </Router>
  );
}

export default App;
